jQuery(function() {
  return $(".modal-content").draggable({
    handle: ".modal-header"
  });
});